<div class="form-group row align-items-center" #parent>
  <div class="chart-container">
    <canvas height="500" width="700" id="myChart" #myChart></canvas>
  </div>
</div>
